export default {
  path: 'aggregator/roads',
  name: 'Eregulation-roads',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/AggregatorRoads.vue')
}
